/* Képernyőstop téma – interakciók */
(function () {
  'use strict';
  var KS = window.KS || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function formatMoney(cents) {
    var fmt = KS.moneyFormat || '{{amount_no_decimals_with_space_separator}} Ft';
    var n = (cents / 100);
    function group(num, dec, th, ds) {
      var parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(ds);
    }
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var v;
    switch (m ? m[1] : 'amount_no_decimals_with_space_separator') {
      case 'amount': v = group(n, 2, ',', '.'); break;
      case 'amount_no_decimals': v = group(n, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = group(n, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = group(n, 0, '.', ','); break;
      case 'amount_with_space_separator': v = group(n, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': v = group(n, 2, ' ', '.'); break;
      default: v = group(n, 0, ' ', ','); break;
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, v).replace(/<[^>]*>/g, '');
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  /* toast */
  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-visible');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }

  /* fejléc */
  var header = $('.header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }
  var mnav = $('.mobile-nav');
  $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { mnav && mnav.classList.add('is-open'); b.setAttribute('aria-expanded', 'true'); document.body.style.overflow = 'hidden'; }); });
  $$('[data-menu-close], .mobile-nav a').forEach(function (b) { b.addEventListener('click', function () { mnav && mnav.classList.remove('is-open'); $$('[data-menu-open]').forEach(function (x) { x.setAttribute('aria-expanded', 'false'); }); document.body.style.overflow = ''; }); });

  /* felbukkanó elemek */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else { $$('.reveal').forEach(function (el) { el.classList.add('is-in'); }); }

  /* kosár */
  var drawer = $('#CartDrawer');
  var cartState = null;
  var cartUpdating = false;
  function setCartBusy(busy) {
    cartUpdating = busy;
    $$('[data-qty], [data-add-variant], [data-product-form] [type="submit"], [data-checkout-form] [type="submit"]').forEach(function (b) {
      if (busy && !b.disabled) { b.setAttribute('data-cart-busy', ''); b.disabled = true; }
      if (!busy && b.hasAttribute('data-cart-busy')) { b.disabled = false; b.removeAttribute('data-cart-busy'); }
    });
  }
  function showCartPending() {
    if (!drawer) return;
    $('[data-drawer-body]', drawer).innerHTML = '<p role="status">Csomag hozzáadása…</p>';
    $('[data-drawer-foot]', drawer).hidden = true;
    openDrawer();
  }
  function showQuantityPending(line, quantity) {
    $$('[data-qty="' + line + '"]').forEach(function (b) {
      var row = b.closest('.cart-line');
      if (!row) return;
      if (!quantity) row.style.display = 'none';
      else { var value = $('.qty span', row); if (value) value.textContent = quantity; var price = $('.price', row); if (price) price.textContent = 'Frissítés…'; }
    });
    $$('[data-cart-total], .cart-total span:last-child').forEach(function (el) { el.textContent = 'Frissítés…'; });
  }
  function api(url, body) {
    return fetch(url, { method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: body ? JSON.stringify(body) : undefined, credentials: 'same-origin' })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) { throw j; } return j; }); });
  }
  function getCart() { return api(KS.routes.cart + '.js').then(function (c) { cartState = c; return c; }); }
  /* A Shopify a hozzáadással együtt visszaadja a hiteles kosáradatokat. */
  function addCart(items) {
    return api(KS.routes.cart_add + '.js', { items: items, sections: ['main-cart'], sections_url: KS.routes.cart }).then(function (response) {
      try {
        var html = response.sections && response.sections['main-cart'];
        if (typeof html !== 'string') throw new Error('Missing cart section');
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var data = parsed.querySelector('[data-ks-cart-state]');
        var c = data && JSON.parse(data.textContent);
        if (!c || !Array.isArray(c.items) || typeof c.total_price !== 'number' || typeof c.item_count !== 'number') throw new Error('Invalid cart section');
        cartState = c; return c;
      } catch (_) {
        return getCart();
      }
    });
  }
  function updateCount(c) { $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count || ''; el.setAttribute('data-count', c.item_count); }); }
  function upsellData() { var el = $('#UpsellData'); if (!el) return null; try { return JSON.parse(el.textContent); } catch (e) { return null; } }

  function renderDrawer(c) {
    if (!drawer) return;
    updateCount(c);
    var body = $('[data-drawer-body]', drawer), foot = $('[data-drawer-foot]', drawer);
    if (!c.item_count) {
      body.innerHTML = '<div class="empty-state"><p><strong>A kosarad még üres.</strong></p><p>Válaszd ki a gyermeked korosztályát, és már ma elkezdhetitek.</p><a class="btn" href="' + KS.routes.root + 'collections/all">Csomagok megtekintése</a></div>';
      foot.hidden = true; return;
    }
    foot.hidden = false;
    var html = '';
    c.items.forEach(function (it, i) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=176' : '';
      html += '<div class="cart-line">' +
        (img ? '<img src="' + img + '" alt="" width="88" height="88" loading="lazy">' : '<span></span>') +
        '<div><a class="cart-line__title" href="' + it.url + '">' + esc(it.product_title) + '</a>' +
        (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="cart-line__meta">' + esc(it.variant_title) + '</div>' : '') +
        '<div class="qty" role="group" aria-label="Mennyiség"><button type="button" data-qty="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Csökkentés">−</button><span>' + it.quantity + '</span><button type="button" data-qty="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Növelés">+</button></div></div>' +
        '<div style="text-align:right"><div class="price">' + formatMoney(it.final_line_price) + '</div><button type="button" class="cart-line__remove" data-qty="' + (i + 1) + '" data-q="0">Törlés</button></div></div>';
    });
    var up = upsellData();
    if (up && up.available && !c.items.some(function (it) { return it.variant_id === up.variant_id; })) {
      html += '<div class="upsell-card">' + (up.image ? '<img src="' + up.image + '" alt="" width="72" height="72" loading="lazy">' : '<span></span>') +
        '<div><h3>' + esc(up.heading) + '</h3><p>' + esc(up.text) + '</p><div class="row"><span class="price">+ ' + formatMoney(up.price) + '</span>' +
        '<button type="button" class="btn btn--sm" data-add-variant="' + up.variant_id + '">Hozzáadom</button></div></div></div>';
    }
    body.innerHTML = html;
    $('[data-cart-total]', drawer).textContent = formatMoney(c.total_price);
  }

  function openDrawer() {
    if (!drawer) { window.location.href = KS.routes.cart; return; }
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
    var closeBtn = $('[data-drawer-close]', drawer); closeBtn && setTimeout(function () { closeBtn.focus(); }, 50);
  }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  $$('[data-cart-open]').forEach(function (a) { a.addEventListener('click', function (e) { if (!drawer) return; e.preventDefault(); if (cartUpdating) { openDrawer(); return; } if (cartState) renderDrawer(cartState); else { $('[data-drawer-body]', drawer).innerHTML = '<p role="status">Kosár betöltése…</p>'; $('[data-drawer-foot]', drawer).hidden = true; } openDrawer(); getCart().then(renderDrawer).catch(function () { toast('A kosár nem töltődött be. Próbáld újra.'); }); }); });

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-qty]');
    if (q) {
      e.preventDefault();
      if (cartUpdating) return;
      var line = parseInt(q.getAttribute('data-qty'), 10), quantity = parseInt(q.getAttribute('data-q'), 10);
      setCartBusy(true); showQuantityPending(line, quantity);
      api(KS.routes.cart_change + '.js', { line: line, quantity: quantity }).then(function (c) { cartState = c; renderDrawer(c); renderCartPage(c); })
        .catch(function (err) { toast((err && err.description) || 'Nem sikerült módosítani a kosarat. Próbáld újra.'); if (cartState) { renderDrawer(cartState); renderCartPage(cartState); } })
        .finally(function () { setCartBusy(false); });
      return;
    }
    var addV = e.target.closest('[data-add-variant]');
    if (addV) {
      e.preventDefault(); if (cartUpdating) return;
      setCartBusy(true); addV.classList.add('is-loading');
      if (!document.body.classList.contains('template-cart')) showCartPending();
      addCart([{ id: parseInt(addV.getAttribute('data-add-variant'), 10), quantity: 1 }]).then(function (c) { renderDrawer(c); renderCartPage(c); toast('Hozzáadva a kosárhoz'); })
        .catch(function (err) { if (cartState) renderDrawer(cartState); toast((err && err.description) || 'Nem sikerült hozzáadni.'); })
        .finally(function () { addV.classList.remove('is-loading'); setCartBusy(false); });
    }
  });

  /* Kosár frissítése helyben, a pénztárűrlap megtartásával. */
  function renderCartPage(c) {
    if (!document.body.classList.contains('template-cart')) return;
    var page = $('.cart-page'), grid = $('#CartGrid');
    if (!page || !grid) return;
    var empty = $('[data-cart-empty]', page);
    if (!c.item_count) {
      grid.style.display = 'none';
      if (!empty) {
        empty = document.createElement('div'); empty.className = 'empty-state'; empty.setAttribute('data-cart-empty', '');
        empty.innerHTML = '<p class="lead">A kosarad még üres.</p><a class="btn" href="' + KS.routes.root + '#korosztaly">Csomagot választok</a>';
        page.appendChild(empty);
      }
      return;
    }
    if (empty) empty.remove(); grid.style.display = '';
    var items = $('[data-drawer-body]', drawer);
    if (items) grid.firstElementChild.innerHTML = items.innerHTML;
    var total = $('.cart-total span:last-child', grid);
    if (total) total.textContent = formatMoney(c.total_price);
  }

  /* hozzájárulás a fizetés előtt */
  function bindConsent(scope) {
    $$('[data-checkout-form]', scope).forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (cartUpdating) { e.preventDefault(); toast('A kosár frissül, egy pillanat…'); return; }
        var box = $('[name="attributes[Digitális tartalom – elállási jogról lemondás]"]', form);
        if (KS.requireConsent && box && !box.checked) {
          e.preventDefault();
          var wrap = box.closest('.consent'); wrap && wrap.classList.add('is-error');
          toast('Kérjük, fogadd el a nyilatkozatot a fizetés előtt.'); box.focus();
        }
      });
    });
  }
  bindConsent(document);
  document.addEventListener('change', function (e) { if (e.target.closest('.consent')) e.target.closest('.consent').classList.remove('is-error'); });

  /* termék űrlap */
  $$('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (cartUpdating) return;
      setCartBusy(true); showCartPending();
      var btn = $('[type="submit"]', form); btn && btn.classList.add('is-loading');
      var id = parseInt($('[name="id"]', form).value, 10);
      var items = [{ id: id, quantity: 1 }];
      var bump = $('[data-bump]', form.closest('[data-product]') || document);
      if (bump && bump.checked) items.push({ id: parseInt(bump.value, 10), quantity: 1 });
      addCart(items).then(function (c) { renderDrawer(c); openDrawer(); })
        .catch(function (err) { if (cartState) renderDrawer(cartState); toast((err && err.description) || 'Nem sikerült a kosárba tenni.'); })
        .finally(function () { btn && btn.classList.remove('is-loading'); setCartBusy(false); });
    });
  });

  /* változatválasztó */
  $$('[data-product]').forEach(function (root) {
    var json = $('[data-variants]', root); if (!json) return;
    var variants = JSON.parse(json.textContent);
    var idInput = $('form[data-product-form] [name="id"]', root);
    $$('[data-variant-pick]', root).forEach(function (r) {
      r.addEventListener('change', function () {
        var v = variants.filter(function (x) { return String(x.id) === r.value; })[0]; if (!v) return;
        idInput.value = v.id;
        $$('[data-price]', root).forEach(function (el) { el.textContent = formatMoney(v.price); });
        $$('[data-compare]', root).forEach(function (el) { el.textContent = v.compare_at_price > v.price ? formatMoney(v.compare_at_price) : ''; });
        $$('[data-save]', root).forEach(function (el) { el.hidden = !(v.compare_at_price > v.price); el.textContent = v.compare_at_price > v.price ? 'Megtakarítás: ' + formatMoney(v.compare_at_price - v.price) : ''; });
        if (v.featured_image_index != null) { var t = $$('[data-thumb]', root)[v.featured_image_index]; t && t.click(); }
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url.toString());
      });
    });
    /* galéria */
    var main = $('.product__main-img img', root);
    function preloadProductImage(thumb) {
  if (thumb.dataset.preloaded) return;
  var src = thumb.getAttribute('data-src');
  if (!src) return;
  var image = new Image();
  image.decoding = 'async';
  image.fetchPriority = 'low';
  image.sizes = main.sizes || '100vw';
  image.srcset = thumb.getAttribute('data-srcset') || '';
  image.src = src;
  thumb.dataset.preloaded = 'true';
}
$$('[data-thumb]', root).forEach(function (t) {
  ['pointerenter', 'focus', 'touchstart'].forEach(function (eventName) {
    t.addEventListener(eventName, function () { preloadProductImage(t); }, { once: true, passive: true });
  });
      t.addEventListener('click', function () {
        $$('[data-thumb]', root).forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
        main.src = t.getAttribute('data-src'); main.srcset = t.getAttribute('data-srcset') || ''; main.alt = t.getAttribute('data-alt') || '';
      });
    });
    /* ragadós vásárlás mobilon */
    var sticky = $('.sticky-buy', root), mainBtn = $('form[data-product-form] [type="submit"]', root);
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { sticky.classList.toggle('is-visible', !es[0].isIntersecting && es[0].boundingClientRect.top < 0); }).observe(mainBtn);
      $('[data-sticky-buy]', sticky).addEventListener('click', function () { mainBtn.click(); });
    }
  });

  /* első betöltéskor számláló */
  if ($('[data-cart-count]')) { getCart().then(updateCount).catch(function () {}); }

  /* Csak nyilvános boltoldalak előtöltése a választási szándékra. */
  var prefetchedPages = {}, prefetchCount = 0;
  function publicLink(target) {
    var a = target.closest && target.closest('a[href]');
    if (!a || a.hasAttribute('download') || a.target === '_blank' || a.hasAttribute('data-cart-open')) return null;
    var u; try { u = new URL(a.href, location.href); } catch (_) { return null; }
    if (u.origin !== location.origin || u.search || !/^\/(products\/|collections\/|pages\/|$)/.test(u.pathname)) return null;
    if (u.pathname === location.pathname) return null;
    return { anchor: a, url: u };
  }
  function prefetchPage(e) {
    var link = publicLink(e.target);
    if (!link || prefetchCount >= 6 || prefetchedPages[link.url.pathname]) return;
    prefetchedPages[link.url.pathname] = true; prefetchCount++;
    var hint = document.createElement('link'); hint.rel = 'prefetch'; hint.as = 'document'; hint.href = link.url.origin + link.url.pathname; document.head.appendChild(hint);
  }
  document.addEventListener('pointerover', prefetchPage, { passive: true });
  document.addEventListener('focusin', prefetchPage);
  document.addEventListener('touchstart', prefetchPage, { passive: true });
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) return;
    if (publicLink(e.target)) document.body.classList.add('is-navigating');
  });
  window.addEventListener('pageshow', function () { document.body.classList.remove('is-navigating'); });
})();
